var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"support-container"},[_c('a',{attrs:{"href":"http://t.me/QRWaiterSupportBot","target":"_blank"}},[_vm._v("@QRWaiter")])])}]

export { render, staticRenderFns }